import styled from "styled-components";
import { theme } from "../../../theme";

export const HeaderBlock = styled.header`
    display: flex;
    flex-direction: column;
    padding: 20vh 0 50px;
    background-image: url("/images/intro.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    min-height: 100vh;
    color: ${theme.colors.white};
    margin-bottom: 70px;
    @media (max-width: ${theme.breakpoints.mobile}) {
        margin-bottom: 30px;
    }
`;

export const TitleBlock = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 7%;
    max-width: 55vw;
    font-weight: ${theme.fonts.weights.superBold};
    @media (max-width: ${theme.breakpoints.mobile}) {
        margin-left: 5%;
        max-width: 70vw;
    }
`;

export const Title = styled.h1`
    margin: 0;
    font-size: 120px;
    @media (max-width: ${theme.breakpoints.tablet}) {
       font-size: 80px;
    }
    @media (max-width: ${theme.breakpoints.mobile}) {
       font-size: 50px;
    }
`;

export const SubTitle = styled.h2`
    margin: 0 0 30px 250px;
    font-size: 70px;
    @media (max-width: ${theme.breakpoints.tablet}) {
       font-size: 50px;
       margin: 0 0 30px 150px;
    }
    @media (max-width: ${theme.breakpoints.mobile}) {
       font-size: 30px;
       margin: 0 0 15px 100px;
    }
`;

export const Description = styled.span`
    font-size: 30px;
    font-weight: ${theme.fonts.weights.medium};
    margin-bottom: 60px;
    @media (max-width: ${theme.breakpoints.tablet}) {
       font-size: 20px;
       margin-bottom: 40px;
    }
    @media (max-width: ${theme.breakpoints.mobile}) {
       font-size: 13px;
       margin-bottom: 20px;
    }
`;

export const NavigationButton = styled.a`
    align-self: flex-start;
    cursor: pointer;    
    padding: 12px 25px;
    border-radius: 4px;
    margin-left: 30px;
    font-size: 28px;
    background-color: ${theme.colors.colorfulBackground};
    border: 1px solid ${theme.colors.colorfulBackground};
    color: ${theme.colors.white};
    font-weight: ${theme.fonts.weights.superBold} ;
    transition: 300ms;
    &&:hover{
        background: none;
        transform: translateY(-5px)
    }
    &&:active{
        transform: translateY(0);
        transition: 0ms;
        background-color: ${theme.colors.text};
    }
    @media (max-width: ${theme.breakpoints.tablet}) {
       font-size: 20px;
    }
    @media (max-width: ${theme.breakpoints.mobile}) {
        font-size: 13px;
        margin-left: 10px;
    }
`;